import moment from 'moment';
import React, { useState } from 'react';
import CancellationModal from '../CancellationModal';
import useCancelSubscription from '../hooks/useCancelSubscription';

type Props = {
    subscriptionStatus: string;
    planName: string;
    planPrice: number;
    planIntervalUnit: string;
    planIntervalLength: number;
    currentPeriodEnd: string;
    isInFreeTrial?: boolean;
    includeRestartNote?: boolean;
};

export default function SubscriptionPlansHeader({
    subscriptionStatus,
    planName,
    planPrice,
    planIntervalUnit,
    planIntervalLength,
    currentPeriodEnd,
    isInFreeTrial,
    includeRestartNote,
}: Props) {
    const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
    const { cancelSubscription, isCancellingSubscription } = useCancelSubscription();

    const formattedCurrentPeriodEnd = moment(currentPeriodEnd, 'YYYY-MM-DDTHH:mm:ss').format('MMM DD, YYYY');

    return (
        <div className="subscription-status">
            {subscriptionStatus === 'expired' ? (
                <h3>Your subscription for the {planName} Plan has expired!</h3>
            ) : (
                <h3>
                    You're currently using the {planName} Plan - ${planPrice / 100}/{planIntervalUnit === 'month' && planIntervalLength === 1 ? 'mo' : 'year'}
                </h3>
            )}

            {subscriptionStatus === 'canceled' && (
                <>
                    <h5>
                        Your subscription was canceled but it will remain active until the end of the period:&nbsp;
                        {formattedCurrentPeriodEnd}
                    </h5>
                    {includeRestartNote && <h5>Choosing a plan below will restart your subscription. Your card stays the same.</h5>}
                </>
            )}

            {subscriptionStatus === 'active' && (
                <div>
                    <h5>Your next payment will be on {formattedCurrentPeriodEnd}</h5>
                    <span
                        className="cancel-subscription"
                        onClick={() => setIsModalVisible(true)}
                    >
                        Cancel subscription
                    </span>
                    {isModalVisible && (
                        <CancellationModal
                            title="Confirm subscription cancellation"
                            showInfo={true}
                            showFreeTrialInfo={isInFreeTrial}
                            isLoading={isCancellingSubscription}
                            onConfirmCancellation={cancelSubscription}
                            onClose={() => setIsModalVisible(false)}
                        />
                    )}
                </div>
            )}
        </div>
    );
}
